import Instance from './interceptor';
import Toast from '../components/pages/utils/Toast';
import { API } from '../constants/Constants';
import { DOCUMENT_TOAST, GLOBAL_TOAST } from '../constants/toastConstant';

export const getAllFlowData = async (filter) => {
  const data = {
    flowName: filter?.name,
    flowStatus: filter?.status,
  };
  try {
    const response = await Instance.post(`${API.ALL_FLOWS}`, data);
    const hasSearchCriteria =
      filter?.name?.length > 0 || filter?.status?.length > 0;
    if (hasSearchCriteria && response?.data?.flows?.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return response?.data?.flows;
    }
    return response?.data?.flows;
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: GLOBAL_TOAST.NETWORK_ERROR, variant: 'error' });
    }
  }
};

export const getDashboardFlowsData = async (filter) => {
  const data = {
    flowName: filter?.name,
    flowStatus: filter?.status,
    documentTypes: filter?.typePayloadArr,
  };
  try {
    const response = await Instance.post(`${API.DASHBOARD_FLOWS}`, data);
    const hasSearchCriteria =
      filter?.name?.length > 0 || filter?.status?.length > 0;
    if (hasSearchCriteria && response?.data?.flows?.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return response?.data?.flows;
    }
    return response?.data?.flows;
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: GLOBAL_TOAST.NETWORK_ERROR, variant: 'error' });
    }
  }
};

export const addInvoiceConfigurationFlow = async (formData) => {
  try {
    const response = await Instance.post(`${API.ADD_FLOW}`, formData);
    if (response) {
      return response?.data;
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: GLOBAL_TOAST.NETWORK_ERROR, variant: 'error' });
    }
  }
};

export const updateTimeStampForFlow = async (id) => {
  try {
    const response = await Instance.patch(`${API.UPDATE_TIMESTAMP}/${id}`);
    if (response?.status === 200) {
      return response?.data?.flowId;
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: GLOBAL_TOAST.NETWORK_ERROR, variant: 'error' });
    }
  }
};

export const getFlowById = async (id) => {
  try {
    const response = await Instance.get(`${API.SINGLE_FLOW}/${id}`);
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: GLOBAL_TOAST.NETWORK_ERROR, variant: 'error' });
    }
  }
};

export const editInvoiceConfigurationFlow = async (id, status) => {
  try {
    const response = await Instance.patch(`${API.EDIT_FLOW}?flowId=${id}`, {
      status,
    });
    if (response?.status === 200) {
      return response;
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: GLOBAL_TOAST.NETWORK_ERROR, variant: 'error' });
    }
  }
};

export const deleteFlow = async (id) => {
  try {
    const response = await Instance.delete(`${API.DELETE_FLOW}?flowId=${id}`);
    if (response?.status === 200) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response?.status;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const deleteMultipleFlows = async (ids) => {
  try {
    const response = await Instance.delete(`${API.DELETE_MULTIPLE_FLOW}`, {
      data: { ids },
    });
    if (response?.status === 200) {
      return response?.status;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const editFlow = async (id, payload) => {
  try {
    const response = await Instance.patch(
      `${API.RENAME_FLOW}?flowId=${id}`,
      payload,
    );
    if (response?.status === 200) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response?.data;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const updateDetails = async (id, data, credential, displayName) => {
  const details = {
    details: data,
    credential,
  };
  if (displayName && displayName.trim() !== '') {
    details.display_name = displayName;
  }
  try {
    await Instance.patch(`${API.UPDATE_DETAILS}/${id}`, details);
    // if (response) {
    //   Toast({ message: 'Changes saved successfully', variant: 'success' });
    // }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const odooAuthentication = async (payload) => {
  const { dbName, password, url, userName } = payload;
  const data = {
    db: dbName,
    username: userName,
    password,
    url,
  };
  try {
    const response = await Instance.post(`${API.ODOOAUTH_FLOW}`, data);
    if (response?.status === 200) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response?.data;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const xeroAuthentication = async (type, documentType) => {
  try {
    const response = await Instance.get(
      `${API.XERO_AUTH_FLOW}?exportType=${type}&documentType=${documentType}`,
    );
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const tokenExchangeForXero = async (code, type, documentType) => {
  try {
    const response = await Instance.get(
      `${API.XERO_AUTH_FLOW_CALLBACK}?code=${code}&exportType=${type}&documentType=${documentType}`,
    );
    if (response?.data?.token) {
      return response?.data?.token;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const zohoAuthentication = async (type, documentType) => {
  try {
    const response = await Instance.get(
      `${API.ZOHOAUTH_FLOW}?exportType=${type}&documentType=${documentType}`,
    );
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const tokenExchange = async (code, type, documentType) => {
  try {
    const response = await Instance.get(
      `${API.ZOHOAUTH_FLOW_CALLBACK}?code=${code}&exportType=${type}&documentType=${documentType}`,
    );
    if (response?.data?.token) {
      return response?.data?.token;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const microsoftAuthentication = async (type) => {
  try {
    const response = await Instance.get(
      `${API.MICROSOFT_AUTH_FLOW}?importType=${type}`,
    );
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const tokenExchangeForMicrosoft = async (code, type) => {
  try {
    const response = await Instance.get(
      `${API.MICROSOFT_AUTH_FLOW_CALLBACK}?code=${code}&importType=${type}`,
    );
    if (response?.data?.token) {
      return response?.data?.token;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const getAllUserFromCredential = async (type) => {
  try {
    const response = await Instance.get(`${API.GET_USER_FROM_CREDENTIAL}`, {
      params: {
        type,
      },
    });
    if (response?.status === 200) {
      return response?.data?.users;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const deleteUserFromCredential = async (id) => {
  try {
    const response = await Instance.delete(
      `${API.DELETE_USER_FROM_CREDENTIAL}/${id}`,
    );
    if (response?.status === 200) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response?.data;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};
